/**
 * @generated SignedSource<<c1920678d07fcb5de906352436e03169>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReferralState = "ACCEPTED" | "DECLINED" | "SENT";
export type ClaimYourAccountFlowQuery$variables = {
  slug: string;
};
export type ClaimYourAccountFlowQuery$data = {
  readonly referralBySlug: {
    readonly __typename: string;
    readonly company?: {
      readonly id: string;
    } | null;
    readonly id: string;
    readonly state: ReferralState;
    readonly " $fragmentSpreads": FragmentRefs<"BannerSwitch_banner" | "ReferralFlowSwitch_referral">;
  } | null;
};
export type ClaimYourAccountFlowQuery = {
  response: ClaimYourAccountFlowQuery$data;
  variables: ClaimYourAccountFlowQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientDisplayName",
  "storageKey": null
},
v8 = [
  (v6/*: any*/)
],
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNode",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v6/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "OptionalCompanyInterface",
  "abstractKey": "__isOptionalCompanyInterface"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClaimYourAccountFlowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "referralBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNode",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "IndifyToPartnerReferralNode",
            "abstractKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReferralFlowSwitch_referral"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BannerSwitch_banner"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClaimYourAccountFlowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "referralBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isReferralInterface"
          },
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recipientEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "sender",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNode",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompanyNode",
                        "kind": "LinkedField",
                        "name": "company",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "OptionalCompanyInterface",
                    "abstractKey": "__isOptionalCompanyInterface"
                  }
                ],
                "type": "ReferralInterface",
                "abstractKey": "__isReferralInterface"
              }
            ],
            "type": "IndifyToPartnerReferralNode",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/)
                ],
                "type": "ReferralInterface",
                "abstractKey": "__isReferralInterface"
              }
            ],
            "type": "IndifyToArtistReferralNode",
            "abstractKey": null
          },
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v8/*: any*/),
            "type": "PartnerToPartnerReferralNode",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cbd0861345b391f214a45bd8fca6a21d",
    "id": null,
    "metadata": {},
    "name": "ClaimYourAccountFlowQuery",
    "operationKind": "query",
    "text": "query ClaimYourAccountFlowQuery(\n  $slug: String!\n) {\n  referralBySlug(slug: $slug) {\n    __typename\n    __isReferralInterface: __typename\n    id\n    state\n    ... on IndifyToPartnerReferralNode {\n      company {\n        id\n      }\n    }\n    ...ReferralFlowSwitch_referral\n    ...BannerSwitch_banner\n  }\n}\n\nfragment ArtistDetails_referral on IndifyToArtistReferralNode {\n  id\n  thumbnailUrl\n}\n\nfragment BannerSwitch_banner on ReferralInterface {\n  __isReferralInterface: __typename\n  __typename\n  ... on IndifyToPartnerReferralNode {\n    company {\n      id\n    }\n  }\n  ...InvitedToCompanyTeam_referral\n  ...NonReferralAcceptanceArtist_referral\n  ...NonReferralAcceptancePartner_referral\n  ...ReferralAcceptance_referral\n}\n\nfragment ConfirmAccountInfo_referral on ReferralInterface {\n  __isReferralInterface: __typename\n  __typename\n  recipientEmail\n  ...SectionCompany_referral\n  ... on IndifyToArtistReferralNode {\n    recipientDisplayName\n  }\n  ... on IndifyToPartnerReferralNode {\n    recipientDisplayName\n  }\n}\n\nfragment IndifyToArtistReferralFlow_referral on IndifyToArtistReferralNode {\n  ...Page_referral\n}\n\nfragment IndifyToPartnerReferralFlow_referral on IndifyToPartnerReferralNode {\n  company {\n    id\n  }\n  ...Page_referral\n}\n\nfragment InvitedToCompanyTeam_referral on ReferralInterface {\n  __isReferralInterface: __typename\n  ... on PartnerToCompanyPartnerReferralNode {\n    sender {\n      __typename\n      displayName\n      thumbnailUrl\n      id\n    }\n  }\n  ... on OptionalCompanyInterface {\n    __isOptionalCompanyInterface: __typename\n    company {\n      displayName\n      thumbnailUrl\n      id\n    }\n  }\n}\n\nfragment NonReferralAcceptanceArtist_referral on IndifyToArtistReferralNode {\n  recipientDisplayName\n}\n\nfragment NonReferralAcceptancePartner_referral on IndifyToPartnerReferralNode {\n  recipientDisplayName\n  company {\n    displayName\n    id\n  }\n}\n\nfragment Page_referral on ReferralInterface {\n  __isReferralInterface: __typename\n  ...ConfirmAccountInfo_referral\n  ...ArtistDetails_referral\n  ...PartnerAddCompanyInfo_referral\n}\n\nfragment PartnerAddCompanyInfo_referral on ReferralInterface {\n  __isReferralInterface: __typename\n  id\n  ... on IndifyToPartnerReferralNode {\n    thumbnailUrl\n  }\n  ... on PartnerToPartnerReferralNode {\n    thumbnailUrl\n  }\n}\n\nfragment PartnerToCompanyPartnerReferralFlowFragment_referral on ReferralInterface {\n  __isReferralInterface: __typename\n  ...Page_referral\n}\n\nfragment ReferralAcceptance_referral on ReferralInterface {\n  __isReferralInterface: __typename\n  sender {\n    __typename\n    displayName\n    thumbnailUrl\n    id\n  }\n}\n\nfragment ReferralFlowSwitch_referral on ReferralInterface {\n  __isReferralInterface: __typename\n  __typename\n  ...IndifyToArtistReferralFlow_referral\n  ...IndifyToPartnerReferralFlow_referral\n  ...PartnerToCompanyPartnerReferralFlowFragment_referral\n}\n\nfragment SectionCompanyKnown_referral on OptionalCompanyInterface {\n  __isOptionalCompanyInterface: __typename\n  company {\n    displayName\n    thumbnailUrl\n    id\n  }\n}\n\nfragment SectionCompany_referral on ReferralInterface {\n  __isReferralInterface: __typename\n  __typename\n  ...SectionCompanyKnown_referral\n  ... on IndifyToPartnerReferralNode {\n    company {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1d07a6ee2c19f52b43a80c14555a2ed5";

export default node;
